module.exports = __webpack_public_path__ + "static/media/fly0042.731d51a9.webp";